import React from 'react'
import Banner from '../home/banner/banner'
import Footer from '../footer/footer'
import RightBtn from '../rightBtn/rightBtn';
import DocumentMeta from 'react-document-meta';
require('./appdevelopment.scss')
require('./mobile_appdevelopment.scss')
import { Get, wrapResponse } from './../../requst'


export default class AppDevelopment extends React.Component {
    static async getInitialProps() {
        const [data, seo, caseRes, news] = await Promise.all([
            wrapResponse(Get({ url: 'app/banner' })),
            wrapResponse(Get({ url: 'app/seo' })),
            wrapResponse(Get({ url: 'app/case' })),
            wrapResponse(Get({ url: 'app/news' })),
        ])

        const footerProps = await Footer.getInitialProps()

        return { data, seo, case: caseRes, news, footerProps }
    }

    constructor(props, context) {
        super(props, context)
        this.state = {

        }

    }
    componentDidMount() {
        !function (e) {
            function t(a) { if (i[a]) return i[a].exports; var n = i[a] = { exports: {}, id: a, loaded: !1 }; return e[a].call(n.exports, n, n.exports, t), n.loaded = !0, n.exports } var i = {};
            return t.m = e, t.c = i, t.p = "", t(0)
        }([function (e, t) {
            "use strict"; Object.defineProperty(t, "__esModule", { value: !0 });
            var i = window;
            t["default"] = i.flex = function (normal, e, t) {
                var a = e || 100, n = t || 1, r = i.document, o = navigator.userAgent, d = o.match(/Android[\S\s]+AppleWebkit\/(\d{3})/i), l = o.match(/U3\/((\d+|\.){5,})/i), c = l && parseInt(l[1].split(".").join(""), 10) >= 80, p = navigator.appVersion.match(/(iphone|ipad|ipod)/gi), s = i.devicePixelRatio || 1;
                p || d && d[1] > 534 || c || (s = 1); var u = normal ? 1 : 1 / s, m = r.querySelector('meta[name="viewport"]'); m || (m = r.createElement("meta"), m.setAttribute("name", "viewport"), r.head.appendChild(m)), m.setAttribute("content", "width=device-width,user-scalable=no,initial-scale=" + u + ",maximum-scale=" + u + ",minimum-scale=" + u), r.documentElement.style.fontSize = normal ? "50px" : a / 2 * s * n + "px"
            }, e.exports = t["default"]
        }]); flex(false, 100, 1);

        this.setState({ offsetWidth: document.body.offsetWidth })
    }
    case() {
        return this.props.case.map((item, index) => (
            <a href={`/casedetails/${item.id}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} key={index}>
                <img className="Img" style={{ width: '100%' }} src={item.thumb} alt="" />
                <div className="TextBox" style={{ textAlign: 'center' }}>
                    <a href={`/casedetails/${item.id}`}>{item.title}</a>
                    {/*<p>{item.desc.substring(0,40)}</p>*/}
                </div>
                <div className="Line"></div>
                <div className="Mask"></div>
            </a>
        ))
    }
    news() {
        return this.props.news.map((item, index) => (
            <a key={index} href={`/details/${item.id}`} >
                <div className="ImgBox">
                    <img className="Img" src={item.thumb} alt="" />
                </div>
                <p className="P_Con P_Head">{item.title}</p>
                <p className="P_Con P_Text">{item.desc}</p>
                <div className="Mask_DeatilsBtm"></div>
                <div className="Triangle"></div>
                <div className="MaskText">
                    <p>{item.created_at.substring(0, 7)}</p>
                    <p>{item.created_at.substring(8, 10)}</p>
                    <img src={require('../../assets/common/images/anniujiantou-bai.png')} alt="" />
                </div>
            </a>
        ))
    }
    render() {
        (this.props)
        // (document.body.offsetWidth)
        if (this.state.offsetWidth >= 1200) {

            if (this.props.seo) {
                const meta = {
                    title: this.props.seo.title,
                    description: this.props.seo.description,
                    // link: {
                    //   rel: {
                    //     canonical: 'http://example.com/path/to/sub-page'
                    //   }
                    // },
                    meta: {
                        charSet: 'utf-8',
                        name: {
                            keywords: this.props.seo.keywords
                        },
                    },
                    extend: true
                };
                return (
                    <DocumentMeta {...meta}>
                        <div>
                            <div style={{ width: '100%', height: '630px', display: 'flex', justifyContent: 'center' }}>
                                <img src={this.props.data ? this.props.data[0].photos : null} style={{ height: '100%' }} alt="" />
                            </div>
                            <div className="AppContainer">
                                <div className="App_Middle_one">
                                    <p className="Title">APP开发<span>服务</span></p>
                                    <p className="SubTitle">四川泛梦科技有限公司是西南领先的软件与解决方案提供商。以成熟的智慧、工程师的精神，为客户提供优质的服务与产品</p>
                                    <ul className="IconList">
                                        <li>
                                            <img src={require('../../assets/common/images/ioskaifa@2x.png')} alt="" />
                                            <p className="ListTitle">IOS开发</p>
                                            <p className="Line"></p>
                                            <p className="Content">拥有国内优秀IOS开发团队，为您提供一站式的IOS手机app定制开发服务</p>
                                        </li>
                                        <li>
                                            <img src={require('../../assets/common/images/anzhuo@2x.png')} alt="" />
                                            <p className="ListTitle">安卓开发</p>
                                            <p className="Line"></p>
                                            <p className="Content">安卓APP应用软件已经占据国内移动应用市场的50%以上，开发安卓手机app软件的重要性日益凸显</p>
                                        </li>
                                        <li>
                                            <img src={require('../../assets/common/images/hunhekaifa@2x.png')} alt="" />
                                            <p className="ListTitle">混合开发</p>
                                            <p className="Line"></p>
                                            <p className="Content">HTML5是未来网络发展的趋势，可以实现各种多媒体效果，如视频、音频等无需任何插件即可观看收听</p>
                                        </li>
                                    </ul>
                                </div>
                                <div className="App_Middle_two">
                                    <p className="Title">App强大<span>功能</span></p>
                                    <p className="SubTitle">强大功能，支撑您社交APP应用更多需求</p>
                                    <ul className="IconList">
                                        <li>
                                            <img src={require('../../assets/common/images/gongneng-yuyinduanxin.png')} alt="" />
                                            <p className="ListTitle">支持语音短信</p>
                                            <p className="Content">该功能广泛应用于微信,qq等社交应用，方便用户短时间发送信息。</p>
                                        </li>
                                        <li>
                                            <img src={require('../../assets/common/images/duorenqunliao@2x.png')} alt="" />
                                            <p className="ListTitle">支持多人群聊</p>
                                            <p className="Content">当代社交应用必备功能之一，针对习惯使用微信群聊用户。</p>
                                        </li>
                                        <li>
                                            <img src={require('../../assets/common/images/saoyisao@2x.png')} alt="" />
                                            <p className="ListTitle">支持扫一扫</p>
                                            <p className="Content">支持扫一扫二维码加好友，二维码已经是主流的好友添加方式，便捷、快速。</p>
                                        </li>
                                        <li>
                                            <img src={require('../../assets/common/images/LBSdingwei@2x.png')} alt="" />
                                            <p className="ListTitle">LBS定位</p>
                                            <p className="Content">想查看附近的人？好友？我们利用GPS定位通过引入经纬度计算，结合传统的Haversine formula为您实现此功能。</p>
                                        </li>
                                        <li>
                                            <img src={require('../../assets/common/images/jishichuanda@2x.png')} alt="" />
                                            <p className="ListTitle">即时传达</p>
                                            <p className="Content">此功能可以让您的用户即时了解到信息送达的状态，"送达、一度"等提示让您即时掌握信息是否被对方看到。</p>
                                        </li>
                                        <li>
                                            <img src={require('../../assets/common/images/pengyouquan@2x.png')} alt="" />
                                            <p className="ListTitle">朋友分享圈</p>
                                            <p className="Content">此功能类似微信朋友圈分享，用户可将文字，图片链接等信息分享给特定好友。</p>
                                        </li>
                                    </ul>
                                </div>
                                {this.props.case ? <div className="App_Middle_three">
                                    <p className="Title">APP开发<span>案例</span></p>
                                    <ul className="Content">
                                        {this.case()}
                                    </ul>
                                    <a className="Button" href={`/caseshow?key=1`} >更多</a>
                                </div> : null}
                                <div className="App_Process">
                                    <p className="Title">APP开发流程</p>
                                    <p className="SubTitle">四川泛梦科技有限公司是西南领先的软件与解决方案提供商。以成熟的智慧、工程师的精神，为客户提供优质的服务与产品</p>
                                    <div className="Content">
                                        <div className="Cont_A">
                                            <div className="Cont_Box">
                                                <div className="Img_Box">
                                                    <img src={require('../../assets/common/images/qianqigoutong@2x.png')} alt="" />
                                                </div>
                                            </div>
                                            <div className="Line"></div>
                                            <div className="Dot"></div>
                                            <p className="Head">前期沟通</p>
                                        </div>
                                        <div className="Cont_A">
                                            <div className="Cont_Box">
                                                <div className="Img_Box">
                                                    <img src={require('../../assets/common/images/xuqiupinggu@2x.png')} alt="" />
                                                </div>
                                            </div>
                                            <div className="Line"></div>
                                            <div className="Dot"></div>
                                            <p className="Head">需求评估</p>
                                        </div>
                                        <div className="Cont_A">
                                            <div className="Cont_Box">
                                                <div className="Img_Box">
                                                    <img src={require('../../assets/common/images/UIguihua@2x.png')} alt="" />
                                                </div>
                                            </div>
                                            <div className="Line"></div>
                                            <div className="Dot"></div>
                                            <p className="Head">UI规划</p>
                                        </div>
                                        <div className="Cont_A">
                                            <div className="Cont_Box">
                                                <div className="Img_Box">
                                                    <img src={require('../../assets/common/images/shijuesheji@2x.png')} alt="" />
                                                </div>
                                            </div>
                                            <div className="Line"></div>
                                            <div className="Dot"></div>
                                            <p className="Head">视觉设计</p>
                                        </div>
                                        <div className="Cont_A">
                                            <div className="Cont_Box">
                                                <div className="Img_Box">
                                                    <img src={require('../../assets/common/images/jishukaifa@2x.png')} alt="" />
                                                </div>
                                            </div>
                                            <div className="Line"></div>
                                            <div className="Dot"></div>
                                            <p className="Head">技术开发</p>
                                        </div>
                                        <div className="Cont_A">
                                            <div className="Cont_Box">
                                                <div className="Img_Box">
                                                    <img src={require('../../assets/common/images/ceshi@2x.png')} alt="" />
                                                </div>
                                            </div>
                                            <div className="Line"></div>
                                            <div className="Dot"></div>
                                            <p className="Head">测试</p>
                                        </div>
                                        <div className="Cont_A">
                                            <div className="Cont_Box">
                                                <div className="Img_Box">
                                                    <img src={require('../../assets/common/images/wanchengjiaofu@2x.png')} alt="" />
                                                </div>
                                            </div>
                                            <div className="Line"></div>
                                            <div className="Dot"></div>
                                            <p className="Head">完成交付</p>
                                        </div>

                                    </div>
                                </div>
                                <div className="App_Middle_four">
                                    <p className="Title">APP开发<span>资讯</span></p>
                                    <p className="SubTitle">强大功能，支撑您社交APP应用更多需求</p>
                                    <ul className="Buttom">
                                        {this.props.news ? this.news() : null}
                                    </ul>
                                    <a href='/newscenter?key=1'>更多</a>
                                </div>
                            </div>
                            <Footer {...this.props.footerProps} />
                            <RightBtn props={this.props} />
                        </div>
                    </DocumentMeta>

                )
            } else {
                return null
            }
        } else {
            return (
                <div className="Mobile_AppContainer">
                    <div className="Mobile_AppShowBox">
                        <p className="Mobile_Title">APP开发<span>服务</span></p>
                        <p className="Mobile_SubTitle">四川泛梦科技有限公司是西南领先的软件与解决方案提供商。以成熟的智慧、工程师的精神，为客户提供优质的服务与产品</p>
                        <img src={require('../../assets/common/images/ioskaifa.png')} alt="" />
                        <p className="Mobile_ImgHead">IOS开发</p>
                        <p className="Line"></p>
                        <p className="TextShow">拥有国内优秀IOS开发团队，为您提供一站式的IOS手机app定制开发服务</p>
                        <img src={require('../../assets/common/images/anzhuo.png')} alt="" />
                        <p className="Mobile_ImgHead">安卓开发</p>
                        <p className="Line"></p>
                        <p className="TextShow">安卓APP应用已占据国内移动应用的50%以上，安卓app软件的重要性日益凸显</p>
                        <img src={require('../../assets/common/images/hunhekaifa.png')} alt="" />
                        <p className="Mobile_ImgHead">混合开发</p>
                        <p className="Line"></p>
                        <p className="TextShow">提供H5混合APP制作服务，开发周期短，费用成本相对较低</p>
                    </div>
                    <div className="Mobile_AppPro">
                        <p className="Mobile_Title">APP开发流程</p>
                        <p className="Mobile_SubTitle">四川泛梦科技有限公司是西南领先的软件与解决方案提供商。以成熟的智慧、工程师的精神，为客户提供优质的服务与产品</p>
                    </div>
                    <div className="Mobile_Case">
                        <p className="Mobile_Title">开发案例</p>
                        <table>
                            <tbody>
                                <tr>
                                    <td><img src={require('../../assets/common/images/shiyan.jpg')} alt="" /></td>
                                    <td><img src={require('../../assets/common/images/shiyan.jpg')} alt="" /></td>
                                </tr>
                                <tr>
                                    <td><img src={require('../../assets/common/images/shiyan.jpg')} alt="" /></td>
                                    <td><img src={require('../../assets/common/images/shiyan.jpg')} alt="" /></td>
                                </tr>
                            </tbody>
                        </table>
                        <a href="/caseshow?key=1">更多</a>
                    </div>
                </div>
            )
        }
    }
}